const underlyingList = [
  {
    name: 'EURO STOXX Banks',
    ticker: 'SX5E Index',
    assetClass: 'Equities',
    group: 'Thematic',
  },
  {
    name: 'S&P 500',
    ticker: 'SPX Index',
    assetClass: 'Equities',
    group: 'Broad Market',
  },
  /*   {
    name: 'NASDAQ 100',
    ticker: 'NDX Index',
    assetClass: 'Equities',
    group: 'Broad Market',
  }, */
  {
    name: 'FTSE 250',
    ticker: 'MCX Index',
    assetClass: 'Equities',
    group: 'Broad Market',
  },
  {
    name: 'FTSE 100',
    ticker: 'UKX Index',
    assetClass: 'Equities',
    group: 'Broad Market',
  },
  {
    name: 'FTSE MIB',
    ticker: 'FTSEMIB Index',
    assetClass: 'Equities',
    group: 'Broad Market',
  },
  /* {
    name: 'CAC 40',
    ticker: '',
    assetClass: 'Equities',
    group: 'Broad Market',
  }, */
  {
    name: 'DAX',
    ticker: 'DAX Index',
    assetClass: 'Equities',
    group: 'Broad Market',
  },
  {
    name: 'EURO STOXX 50',
    ticker: 'SX5E Index',
    assetClass: 'Equities',
    group: 'Broad Market',
  },
  {
    name: 'All Commodities',
    ticker: 'BCOM Index',
    assetClass: 'Commodities',
    group: 'Broad Commodities',
  },
  {
    name: 'Precious Metals',
    ticker: 'BCOMPR Index',
    assetClass: 'Commodities',
    group: 'Precious Metals',
  },
  {
    name: 'Gold',
    ticker: 'BCOMGC Index',
    assetClass: 'Commodities',
    group: 'Precious Metals',
  },
  {
    name: 'Platinum',
    ticker: 'BCOMPL Index',
    assetClass: 'Commodities',
    group: 'Precious Metals',
  },
  /*  {
    name: 'Palladium',
    ticker: 'BCOMPA Index',
    assetClass: 'Commodities',
    group: 'Precious Metals',
  }, */
  {
    name: 'Silver',
    ticker: 'BCOMSI Index',
    assetClass: 'Commodities',
    group: 'Precious Metals',
  },
  {
    name: 'Industrial Metals',
    ticker: 'BCOMIN Index',
    assetClass: 'Commodities',
    group: 'Industrial Metals',
  },
  {
    name: 'Copper',
    ticker: 'BCOMHG Index',
    assetClass: 'Commodities',
    group: 'Industrial Metals',
  },
  {
    name: 'Nickel',
    ticker: 'BCOMNI Index',
    assetClass: 'Commodities',
    group: 'Industrial Metals',
  },
  {
    name: 'Zinc',
    ticker: 'BCOMZS Index',
    assetClass: 'Commodities',
    group: 'Industrial Metals',
  },
  {
    name: 'Lead',
    ticker: 'BCOMPB Index',
    assetClass: 'Commodities',
    group: 'Industrial Metals',
  },
  {
    name: 'Tin',
    ticker: 'BCOMSN Index',
    assetClass: 'Commodities',
    group: 'Industrial Metals',
  },
  {
    name: 'Aluminium',
    ticker: 'BCOMAL Index',
    assetClass: 'Commodities',
    group: 'Industrial Metals',
  },
  {
    name: 'Energy Basket',
    ticker: 'BCOMEN Index',
    assetClass: 'Commodities',
    group: 'Energy',
  },
  {
    name: 'Brent Crude Oil',
    ticker: 'BCOMCO Index',
    assetClass: 'Commodities',
    group: 'Energy',
  },
  {
    name: 'WTI Crude Oil',
    ticker: 'BCOMCL Index',
    assetClass: 'Commodities',
    group: 'Energy',
  },
  {
    name: 'Gasoline',
    ticker: 'BCOMRB Index',
    assetClass: 'Commodities',
    group: 'Energy',
  },
  {
    name: 'Heating Oil',
    ticker: 'BCOMHO Index',
    assetClass: 'Commodities',
    group: 'Energy',
  },
  {
    name: 'Natural Gas',
    ticker: 'BCOMNG Index',
    assetClass: 'Commodities',
    group: 'Energy',
  },
  {
    name: 'Petroleum',
    ticker: 'BCOMPE Index',
    assetClass: 'Commodities',
    group: 'Energy',
  },
  {
    name: 'Agriculture',
    ticker: 'BCOMAG Index',
    assetClass: 'Commodities',
    group: 'Agriculture',
  },
  {
    name: 'Coffee',
    ticker: 'BCOMKC Index',
    assetClass: 'Commodities',
    group: 'Agriculture',
  },
  /* {
    name: 'Cotton',
    ticker: 'BCOMCT Index',
    assetClass: 'Commodities',
    group: 'Agriculture',
  }, */
  {
    name: 'Wheat',
    ticker: 'BCOMWH Index',
    assetClass: 'Commodities',
    group: 'Agriculture',
  },
  {
    name: 'Sugar',
    ticker: 'BCOMSB Index',
    assetClass: 'Commodities',
    group: 'Agriculture',
  },
  /*   {
    name: 'Grains',
    ticker: 'BCOMGR Index',
    assetClass: 'Commodities',
    group: 'Agriculture',
  },
  {
    name: 'Soybeans',
    ticker: 'BCOMSY Index',
    assetClass: 'Commodities',
    group: 'Agriculture',
  }, */
  {
    name: 'Corn',
    ticker: 'BCOMCN Index',
    assetClass: 'Commodities',
    group: 'Agriculture',
  },
  /* {
    name: 'Softs',
    ticker: 'BCOMSO Index',
    assetClass: 'Commodities',
    group: 'Agriculture',
  }, */
  /* {
    name: 'Live Cattle',
    ticker: 'BCOMLC Index',
    assetClass: 'Commodities',
    group: 'Agriculture',
  },
  {
    name: 'Livestock',
    ticker: 'BCOMLI Index',
    assetClass: 'Commodities',
    group: 'Agriculture',
  },
  {
    name: 'Lean Hogs',
    ticker: 'BCOMLH Index',
    assetClass: 'Commodities',
    group: 'Agriculture',
  }, */
  {
    name: 'Cocoa',
    ticker: 'BCOMCC Index',
    assetClass: 'Commodities',
    group: 'Agriculture',
  },

  // currencies
  {
    name: 'GBPUSD',
    ticker: 'GBPUSD Curncy',
    assetClass: 'Currencies',
    group: 'GBP Pairs',
    order: 1,
  },
  {
    name: 'USDGBP',
    ticker: 'USDGBP Curncy',
    assetClass: 'Currencies',
    group: 'USD Pairs',
    order: 2,
  },
  /* {
    name: 'JPYUSD',
    ticker: 'JPYUSD Curncy',
    assetClass: 'Currencies',
    group: 'USD Pairs',
  }, */
  /* {
    name: 'AUDUSD',
    ticker: 'AUDUSD Curncy',
    assetClass: 'Currencies',
    group: 'USD Pairs',
  }, */
  {
    name: 'EURUSD',
    ticker: 'EURUSD Curncy',
    assetClass: 'Currencies',
    group: 'EUR Pairs',
    order: 3,
  },
  {
    name: 'USDEUR',
    ticker: 'USDEUR Curncy',
    assetClass: 'Currencies',
    group: 'USD Pairs',
    order: 4,
  },
  {
    name: 'GBPEUR',
    ticker: 'GBPEUR Curncy',
    assetClass: 'Currencies',
    group: 'GBP Pairs',
    order: 5,
  },
  {
    name: 'EURGBP',
    ticker: 'EURGBP Curncy',
    assetClass: 'Currencies',
    group: 'EUR Pairs',
    order: 6,
  },
  /*   {
    name: 'JPYUSD',
    ticker: 'JPYUSD Curncy',
    assetClass: 'Currencies',
    group: 'JPY Pairs',
    order: 7,
  }, */
  {
    name: 'USDJPY',
    ticker: 'USDJPY Curncy',
    assetClass: 'Currencies',
    group: 'USD Pairs',
    order: 8,
  },
  /* {
    name: 'USDCNY',
    ticker: 'USDCNY Curncy',
    assetClass: 'Currencies',
    group: 'USD Pairs',
    order: 9,
  }, */ // Not available in Bloomberg
  {
    name: 'GBPJPY',
    ticker: 'GBPJPY Curncy',
    assetClass: 'Currencies',
    group: 'GBP Pairs',
    order: 10,
  },
  {
    name: 'GBPCHF',
    ticker: 'GBPCHF Curncy',
    assetClass: 'Currencies',
    group: 'GBP Pairs',
    order: 11,
  },
  {
    name: 'EURAUD',
    ticker: 'EURAUD Curncy',
    assetClass: 'Currencies',
    group: 'EUR Pairs',
    order: 12,
  },
  {
    name: 'EURCHF',
    ticker: 'EURCHF Curncy',
    assetClass: 'Currencies',
    group: 'EUR Pairs',
    order: 13,
  },
  {
    name: 'EURJPY',
    ticker: 'EURJPY Curncy',
    assetClass: 'Currencies',
    group: 'EUR Pairs',
    order: 14,
  },
  {
    name: 'EURNOK',
    ticker: 'EURNOK Curncy',
    assetClass: 'Currencies',
    group: 'EUR Pairs',
    order: 15,
  },
  {
    name: 'EURSEK',
    ticker: 'EURSEK Curncy',
    assetClass: 'Currencies',
    group: 'EUR Pairs',
    order: 16,
  },
  /* {
    name: 'JPYEUR',
    ticker: 'JPYEUR Curncy',
    assetClass: 'Currencies',
    group: 'EUR Pairs',
  }, */
  /* {
    name: 'CADEUR',
    ticker: 'CADEUR Curncy',
    assetClass: 'Currencies',
    group: 'EUR Pairs',
  }, */
  /* {
    name: 'AUDEUR',
    ticker: 'AUDEUR Curncy',
    assetClass: 'Currencies',
    group: 'EUR Pairs',
  }, */
  /* {
    name: 'CHFEUR',
    ticker: 'CHFEUR Curncy',
    assetClass: 'Currencies',
    group: 'EUR Pairs',
  }, */

  /* {
    name: 'AUDGBP',
    ticker: 'AUDGBP Curncy',
    assetClass: 'Currencies',
    group: 'GBP Pairs',
  }, */
  /* {
    name: 'JPYGBP',
    ticker: 'JPYGBP Curncy',
    assetClass: 'Currencies',
    group: 'GBP Pairs',
  }, */

  // fixed income
  // to figure out what index has data; current indexes don't have live data.
  /*
  {
    name: 'BTP 10Y',
    ticker: 'IK1 Comdty',
    assetClass: 'Fixed Income',
    group: 'Sovereign Debt',
  },
  {
    name: 'Bund 10Y',
    ticker: 'RX1 Comdty',
    assetClass: 'Fixed Income',
    group: 'Sovereign Debt',
  },
  {
    name: 'Gilts 10Y',
    ticker: 'G1 Comdty',
    assetClass: 'Fixed Income',
    group: 'Sovereign Debt',
  },
  {
    name: 'US Treasuries',
    ticker: 'TY1 Comdty',
    assetClass: 'Fixed Income',
    group: 'Sovereign Debt',
  }, // */
];
/*
not in list have:
SPVXSP  VIX - NOT SHOWING VIX
*/
export default underlyingList;
